import { parsePhoneNumber } from 'libphonenumber-js'

export function formatDomesticPhone(phone: string | null | undefined) {
  return phone
    ? parsePhoneNumber(phone, 'US')
        .formatNational() // e.g. (949) 288-3523
        .replace(/[()]/g, '')
        .trim()
        .replace(' ', '-') // 949-288-3523
    : ''
}
